<template>
  <div class="tebodyitem">
    <div class="tebodyitem-header"><span>配置内容</span></div>
  </div>
  <div class="tebodyitem">
    <el-form-item label="BC接收邮箱" required>
      <el-input v-model="form.mail" placeholder="请输入" clearable />
    </el-form-item>
    <el-form-item label="订舱联系人">
      <el-input v-model="form.contact" placeholder="请输入" clearable />
    </el-form-item>
    <el-form-item label="订舱手机号">
      <el-input v-model="form.phone" placeholder="请输入" clearable />
    </el-form-item>
  </div>
  <div class="tebodyitem full">
    <el-form-item label="是否需要提单" required>
      <div style="display: flex; align-items: center;width: 100%;">
        <el-radio-group v-model="form.billNeed">
          <el-radio :value="2" size="large">不需要</el-radio>
          <el-radio :value="1" size="large">需要</el-radio>
        </el-radio-group>
        <el-input v-model="form.billAmount" :disabled="form.billNeed == 2" clearable style="width: 56px;margin-left: 5px; margin-right: 5px;" />份
      </div>
    </el-form-item>
  </div>
  <div class="tebodyitem half">
    <el-form-item label="箱型-箱重映射关系" required>
      <div class="tebodyitem-relative-wrap">
        <div class="tebodyitem-relative-header">
          <span>箱型</span><span>箱重</span>
        </div>
        <div class="tebodyitem-relative-body" v-for="(item, index) in weights">
          <el-select v-model="weights[index].containerType" placeholder="请选择" clearable>
            <el-option v-for="(itm, idx) in Object.keys(CONST.CONTAINER_TYPE_LABEL).map(v => ({ value: v, label: CONST.CONTAINER_TYPE_LABEL[v] }))" :label="itm?.label" :value="itm?.value" :key="idx" />
          </el-select>
          <el-icon><Minus color="#D4D7DF" /></el-icon>
          <el-input v-model="weights[index].weight" placeholder="请输入" />kg
          <el-icon><CirclePlusFilled @click="addWeights" color="#4EBE41" /></el-icon>
          <el-icon><RemoveFilled @click="minusWeights(index)" :color="weights.length > 1 ? '#FF4D4F' : '#B6B9BF'" /></el-icon>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="箱型-品名映射关系" required>
      <div class="tebodyitem-relative-wrap">
        <div class="tebodyitem-relative-header">
          <span>箱型</span><span>品名</span>
        </div>
        <div class="tebodyitem-relative-body" v-for="(item, index) in products">
          <el-select v-model="products[index].containerType" placeholder="请选择" clearable>
            <el-option v-for="(itm, idx) in Object.keys(CONST.CONTAINER_TYPE_LABEL).map(v => ({ value: v, label: CONST.CONTAINER_TYPE_LABEL[v] }))" :label="itm?.label" :value="itm?.value" :key="idx" />
          </el-select>
          <el-icon><Minus color="#D4D7DF" /></el-icon>
          <el-input v-model="products[index].product" placeholder="请输入" />
          <el-icon><CirclePlusFilled @click="addProducts" color="#4EBE41" /></el-icon>
          <el-icon><RemoveFilled @click="minusProducts(index)" :color="products.length > 1 ? '#FF4D4F' : '#B6B9BF'" /></el-icon>
        </div>
      </div>
    </el-form-item>
  </div>
  <div class="tebodyitem full">
    <el-form-item label="是否需要填写 HSCODE" required>
      <el-radio-group v-model="form.hscodeNeed">
        <el-radio :value="false" size="large">不需要</el-radio>
        <el-radio :value="true" size="large">需要</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
  <div class="tebodyitem half">
    <el-form-item label="品名-HSCODE映射关系" :required="!!form.hscodeNeed">
      <div class="tebodyitem-relative-wrap">
        <div class="tebodyitem-relative-header">
          <span style="width: 45%;">品名</span><span>HSCODE</span>
        </div>
        <div class="tebodyitem-relative-body" v-for="(item, index) in hsCodes">
          <el-input v-model="hsCodes[index].productCode" placeholder="请输入" />
          <el-icon><Minus color="#D4D7DF" /></el-icon>
          <el-input v-model="hsCodes[index].hsCode" placeholder="请输入" />
          <el-icon><CirclePlusFilled @click="addHsCodes" color="#4EBE41" /></el-icon>
          <el-icon><RemoveFilled @click="minusHsCodes(index)" :color="hsCodes.length > 1 ? '#FF4D4F' : '#B6B9BF'" /></el-icon>
        </div>
      </div>
    </el-form-item>
  </div>
  <MoreSetting>
    <div class="tebodyitem full">
      <el-form-item label="是否需要客户参考填写POL">
        <el-radio-group v-model="form.realcodNonnb">
          <el-radio :value="false" size="large">不需要</el-radio>
          <el-radio :value="true" size="large">需要</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
  </MoreSetting>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close, Search, Minus, ArrowDown, CirclePlus, RemoveFilled, CirclePlusFilled } from '@element-plus/icons-vue'
  import MoreSetting from '../moresetting/index';
  import * as CONST from '@/assets/const'

  const emits = defineEmits([ 'change' ])

  const props = defineProps({
    data: {
      type: Object,
      default: null
    }
  });

  /**
   * 箱型&品名
   */
  const products = ref([
    { containerType: '', product: '' }
  ])
  const addProducts = () => {
    products.value.push({ containerType: '', product: '' })
  }
  const minusProducts = (index) => {
    if(products.value?.length <= 1) return;
    
    products.value.splice(index, 1);
  }

  /**
   * 箱型&重量
   */
  const weights = ref([
    { containerType: '', weight: '' }
  ])
  const addWeights = () => {
    weights.value.push({ containerType: '', weight: '' })
  }
  const minusWeights = (index) => {
    if(weights.value?.length <= 1) return;
    
    weights.value.splice(index, 1);
  }

  /**
   * 箱型&重量
   */
  const hsCodes = ref([
    { hsCode: '', productCode: '' }
  ])
  const addHsCodes = () => {
    hsCodes.value.push({ hsCode: '', productCode: '' })
  }
  const minusHsCodes = (index) => {
    if(hsCodes.value?.length <= 1) return;
    
    hsCodes.value.splice(index, 1);
  }

  const form = ref({ weight: [] })
  watch(() => [ form.value, products.value ], () => {
    emits('change', {
      ...form.value,
      products: products.value,
      weights: weights.value,
      hsCodes: hsCodes.value,
    })
  }, { deep: true });

  const init = () => {
    console.log('props.data------', props.data);
    // 官方报价单接收邮箱账号
    form.value.mail = props.data?.mail;
    form.value.contact = props.data?.contact;
    form.value.phone = props.data?.phone;
    form.value.billNeed = props.data?.billNeed;
    form.value.hscodeNeed = props.data?.hscodeNeed;
    form.value.realcodNonnb = props.data?.realcodNonnb;
    form.value.billAmount = props.data?.billAmount;

    if(props.data?.products) products.value = props.data?.products
    if(props.data?.weights) weights.value = props.data?.weights
    if(props.data?.hsCodes) hsCodes.value = props.data?.hsCodes
  }
  watch(() => props.data, () => {
    init();
  }, { deep: true });
</script>

<style scoped lang="less">
  @import "./index.less";
</style>